import { RadioButtonOption } from "../../../common/enums";

export const WORK_AT_HEIGHT_CHECKLIST_VERSION_2026_02 = 1;

export type WorkAtHeightChecklist = {
    checklistVersion: number | undefined;
    haveCorrectFallProtection: RadioButtonOption;
    isHarnessInspected: RadioButtonOption;
    isConnectedProperly: RadioButtonOption;
    isRiskOfFallingObjects: RadioButtonOption;
    areEscapeRoutesCleared: RadioButtonOption;
    isRiskOfDebris: RadioButtonOption;
    isAreaCordonedOff: RadioButtonOption;
    needsProtectiveNet: RadioButtonOption;
    willBeLooseObjects: RadioButtonOption;
    willBeLooseObjectsComment: string;
    isHarnessInspectedWithinOneYear: RadioButtonOption;
    isSecurelyConnectedToFallProtection: RadioButtonOption;
    howIsAreaBelowCordonedOff: string;
    howAreLooseObjectsSecured: string;
};
